var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:(_vm.$route.name == 'Login' ? 'bg-image' : ''),attrs:{"id":"inspire"}},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"203"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }